import { useTranslation } from 'react-i18next';
import { useSchedulePermissions } from '@/pages/Schedule/hooks';
import { Flex, type FlexProps, Text, Icon, Button } from '@/ui';
import { AddContentButton } from './AddContentButton';

type Props = FlexProps & {
  cta?: JSX.Element | null | undefined;
};

export const EmptyState = ({ cta, ...props }: Props) => {
  const { hasSchedulePermission } = useSchedulePermissions();
  const { t } = useTranslation('schedule', {
    keyPrefix: 'agenda_view.empty_state',
  });

  if (cta === undefined) {
    cta = (
      <AddContentButton
        bg="white"
        color="gray.900"
        fontSize="md"
        variant="secondary"
        buttonComponent={
          <Button leftIcon={<Icon icon="Plus" />}>{t('add_item')}</Button>
        }
      />
    );
  }

  return (
    <Flex
      align="center"
      color="customgray.mid"
      direction="column"
      py="10"
      {...props}
    >
      <Text fontSize={{ base: '2xl', md: '4xl' }} textAlign="center">
        {t('title')}
      </Text>

      <Text mb="8" mt="1">
        {t('message')}
      </Text>

      {hasSchedulePermission('ENTRY_CREATE') && cta ? cta : null}
    </Flex>
  );
};
